import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react'
import { io, Socket } from 'socket.io-client'
import { BASE_URL } from '../config/app.config'
import { getJwtToken } from '../utils/localStorage'
import { isJwtExpired } from '../utils/authSession'

interface SocketContextType {
	socket: Socket | null
}

const SocketContext = createContext<SocketContextType | undefined>(undefined)

export const useSocket = (): Socket | null => {
	const context = useContext(SocketContext)
	if (!context) {
		throw new Error('useSocket must be used within a SocketProvider')
	}
	return context.socket
}

interface SocketProviderProps {
	children: ReactNode
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
	const [socket, setSocket] = useState<Socket | null>(null)
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		const jwt = getJwtToken()
		let newSocket: Socket | null = null

		if (jwt && jwt.length > 0 && !isJwtExpired(jwt)) {
			newSocket = io(BASE_URL, {
				auth: {
					strategy: 'jwt',
					token: jwt,
				},
			})
			setSocket(newSocket)
		}
		setLoading(false)

		return () => {
			if (newSocket) {
				newSocket.close()
			}
		}
	}, [])

	if (loading) {
		return <>Γίνεται φόρτωση...</>
	}

	return <SocketContext.Provider value={{ socket }}>{children}</SocketContext.Provider>
}
